import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { SendNotificationViewModel } from "src/Sell/sendNotification/sendNotification-viewModel";
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { RegisterForServerNotification, ServerNotification, ServerNotificationMessage } from "src/server/serverNotification";
import { SideBarItem } from "src/uicomponents/components/sidebar/sidebar-viewModel";
import { SidebarItemView } from "src/uicomponents/components/sidebar/sidebarItem/sidebarItem-view";
import { PrintDeliveryFormAction } from "src/Warehouse/DeliveryCartable/deliveryCartableDetail/deliveryCartableDetail-viewModel";
import { MediaSelector } from "uicomponents";
import { ThemeSelectorViewModel } from "../themeSelector/themeSelector-viewModel";
import { stringIsNullOrEmpty } from "../utilities";
import { WindowFactory } from "../windowFactory";
import  { UserMainWindowView } from "./userMainWindow-view"
import { UserMainWindowPhoneView } from "./userMainWindowPhone/userMainWindowPhone-view";
import { RequestCloseWindowMessage, WindowContainerViewModel, WindowViewModel } from "./windowContainer/windowContainer-viewModel";

export class UserMainWindowViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.autohide = false;
        this.lastId = new Set<string>();
        this.forms = ObservableArray.create<WindowContainerViewModel>();
        this.filter = new FilterAccessibleFormsViewModel(this);
        this.loggedInPersonnelName = CurrentCredentials.personnelFullName;
        this.loggedInPersonnelCode = CurrentCredentials.personnelCode;
        this.serverNotification = new ServerNotification(()=>CurrentCredentials.username,()=>CurrentCredentials.password);
        let msg = new RegisterForServerNotification("Print_Delivery_Caratable",(command,parameter)=>this.automatedPrintPushReceiver(command,parameter));
        new SendNotificationViewModel(this);
        this.handleMessage(msg);
        this.checkConnectivity();
    }
    
    GetDefaultView(): View <ViewModel> {
        return MediaSelector.GetView({
            default : ()=>new UserMainWindowView(),
            portraitPhone : ()=> new UserMainWindowPhoneView(),
            landscapePhone : ()=> new UserMainWindowPhoneView(),
        });
    }
    public getTypeId(): string {
        return "VM-15D1595C-4B19-4E39-B4C5-FB4DEB2023AA"
    }
    private lastId : Set<string>;
    automatedPrintPushReceiver(command: string, parameter: any): void {
        if(this.lastId.has(parameter.invoiceId)==false){
            this.lastId.add(parameter.invoiceId);
            setTimeout(()=>{
                new PrintDeliveryFormAction().Print(this,parameter.invoiceId, parameter.elementId);
            },10000)
        }

        
    }
    async checkConnectivity(){
        try {
            let result = await ServerConnection.callServer('/Complex/AuthenticationServices/CheckConnection',{});
            if(result.IsSuccessful==false)
                throw "Mac Error";
            this.isConnected = true;
            setTimeout(()=>this.checkConnectivity(),10000);
        } catch (ex) {
            this.isConnected = false;
            setTimeout(()=>this.checkConnectivity(),3000);
        } finally {
        }
    }

    private serverNotification : ServerNotification;
    public set isConnected(v: boolean) { this._isConnected = v; } public get isConnected(): boolean { return this._isConnected;} private _isConnected: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set forms(v: ObservableArray<WindowContainerViewModel>) { this._forms = v; } public get forms(): ObservableArray<WindowContainerViewModel> { return this._forms;} private _forms: ObservableArray<WindowContainerViewModel>;
    public set currentForm(v: WindowContainerViewModel) { 
        this._currentForm = v; 
        if(v?.window?.isShowingPopup == true){
            v.window.isShowingPopup = false;
            setTimeout(()=>{
                v.window.isShowingPopup = true;
            },100)
        }
    } public get currentForm(): WindowContainerViewModel { return this._currentForm;} private _currentForm: WindowContainerViewModel;
    public set filter(v: FilterAccessibleFormsViewModel) { this._filter = v; } public get filter(): FilterAccessibleFormsViewModel { return this._filter;} private _filter: FilterAccessibleFormsViewModel;
    public set loggedInPersonnelName(v: string) { this._loggedInPersonnelName = v; } public get loggedInPersonnelName(): string { return this._loggedInPersonnelName;} private _loggedInPersonnelName: string;
    public set loggedInPersonnelCode(v: string) { this._loggedInPersonnelCode = v; } public get loggedInPersonnelCode(): string { return this._loggedInPersonnelCode;} private _loggedInPersonnelCode: string;
    public set autohide(v: boolean) { this._autohide = v; } public get autohide(): boolean { return this._autohide;} private _autohide: boolean;
    public set themeWindow(v: ThemeSelectorViewModel) { this._themeWindow = v; } public get themeWindow(): ThemeSelectorViewModel { return this._themeWindow;} private _themeWindow: ThemeSelectorViewModel;
    public set shallShowThemes(v: boolean) { this._shallShowThemes = v; } public get shallShowThemes(): boolean { return this._shallShowThemes;} private _shallShowThemes: boolean;
    
    private async addNewWindowFromMessage(message:CreateWindowMessage) : Promise<WindowContainerViewModel>{
        let windowContainer = new WindowContainerViewModel(this);
        let window = await new WindowFactory().getWindow(message,windowContainer);
        windowContainer.window = window;
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return windowContainer;
    }
    private async addNewWindowFromGeneraotrFunction(message:ShowWindowMessage) : Promise<WindowContainerViewModel>{
        let windowContainer = new WindowContainerViewModel(this);
        let window = message.generator(windowContainer);
        windowContainer.window = window;
        await message.furtherLoading(window);
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return windowContainer;
    }
    private closeWindow(window:WindowContainerViewModel){
        if(this.currentForm == window){
            let position = this.forms.indexOf(window);
            this.forms.remove(window);
            if(this.forms.length==0)
                this.currentForm = null;
            else if(this.forms.length>position){
                this.currentForm = this.forms[position];
            }else{
                this.currentForm = this.forms[this.forms.length-1];
            }
        }else{
            this.forms.remove(window)
        }
        
    }
    handleMessage(message : ViewModelMessage){
        if(message instanceof CreateWindowMessage){
            return this.addNewWindowFromMessage(message);
        }else if(message instanceof ServerNotificationMessage){
            return this.serverNotification?.handleMessage(message);
        }else if(message instanceof ShowWindowMessage){
            return this.addNewWindowFromGeneraotrFunction(message);
        }else if(message instanceof RequestCloseWindowMessage){
            this.closeWindow(message.window);
            return message.window;
        }else{
            return super.handleMessage(message);
        }
    }

    toggleAutohide() {
        this.autohide = !this.autohide;
    }
    showThemeWindow(){
        this.shallShowThemes = true;
        this.themeWindow = new ThemeSelectorViewModel(this);
    }
    closeThemeWindow(){
        this.shallShowThemes = false;
        this.themeWindow = null;
    }
}

export class FilterAccessibleFormsViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.filteredAccessibleForms = ObservableArray.create<AccessibleFormViewModel>();
        this.accessibleForms = ObservableArray.create<AccessibleFormViewModel>();
        this.accessibleItems = new Map<string, AccessibleItem>();
        this.refresh();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set filteredAccessibleForms(v: ObservableArray<AccessibleFormViewModel>) { this._filteredAccessibleForms = v; } public get filteredAccessibleForms(): ObservableArray<AccessibleFormViewModel> { return this._filteredAccessibleForms;} private _filteredAccessibleForms: ObservableArray<AccessibleFormViewModel>;    
    public set accessibleForms(v: ObservableArray<AccessibleFormViewModel>) { this._accessibleForms = v; } public get accessibleForms(): ObservableArray<AccessibleFormViewModel> { return this._accessibleForms;} private _accessibleForms: ObservableArray<AccessibleFormViewModel>;
    public set writtenText(v: string) {
        this._writtenText = v;
        this.startFilter();
    } public get writtenText(): string { return this._writtenText;} private _writtenText: string;
    
    public set sideBarItems(v: SideBarItem[]) { this._sideBarItems = v; } public get sideBarItems(): SideBarItem[] { return this._sideBarItems;} private _sideBarItems: SideBarItem[];
    public set accessibleItems(v: Map<string, AccessibleItem>) { this._accessibleItems = v; } public get accessibleItems(): Map<string, AccessibleItem> { return this._accessibleItems;} private _accessibleItems: Map<string, AccessibleItem>;

    async refresh() {
        try{
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/AuthenticationServices/GetAccessibleFormsForCurrentUser', {});
            // result.Forms.push(...[{"Id":"F251C743-19A1-46C0-842F-05EA905E68C8","Name":"مدیریت\/ دستگاه های پوز"},{"Id":"730641AF-56E3-45F9-AFB5-06C2419E18B3","Name":"مدیریت\/ انبارها"},{"Id":"202737FE-51A8-4061-83F7-0FD1D09C6021","Name":"مدیریت\/ مقایسه فروش شعب"},{"Id":"97F51E03-C30C-482F-B404-1B015A240B40","Name":"مدیریت\/ تنظیم بهینه انبار"},{"Id":"C1E57C64-5AAA-4BAB-B612-1DB2BFE3AA89","Name":"مدیریت\/ لوکیشن های کالا"},{"Id":"A336C70F-5ACB-4A55-93DA-21FFD9045F42","Name":"مدیریت\/ PNC"},{"Id":"E3592981-9BB2-4E11-A23D-2641E71785A3","Name":"مدیریت\/ لیست فاکتورهای خرید"},{"Id":"A7A27C4E-7C78-4250-9C17-26FB9D841B4C","Name":"مدیریت\/ درخواست ثبت مشتریان"},{"Id":"E62C49CC-E3F7-49B5-893C-331238CF78B2","Name":"مدیریت\/ درخواست های ایجاد کالا"},{"Id":"654EA7F4-1E30-4F5D-ACAD-3768D380DEF1","Name":"مدیریت\/ استان ها"},{"Id":"B9C9D967-7FDC-4274-A4BA-3D6104B3C797","Name":"مدیریت\/ لیست بدهکاران و بستانکاران"},{"Id":"B17CB9C6-9627-4DDC-B3A1-448154266DE7","Name":"مدیریت\/ اعتبار مشتری"},{"Id":"307BFBE3-A210-47B0-9921-45C4E5F47EE8","Name":"مدیریت\/ صندوق"},{"Id":"181F8BE8-494E-47C5-8EFA-45E031B2DE3D","Name":"مدیریت\/ کارتابل تحویل"},{"Id":"0EBE90E3-7655-46B5-9B26-49EBE19C8458","Name":"مدیریت\/ لیست واریزی ها"},{"Id":"3140910E-3B88-4505-BA02-4C150677BDA2","Name":"مدیریت\/تنظیم موجودی غیر قابل فروش"},{"Id":"27875324-24E9-4A0A-9B1D-4DB93D015817","Name":"مدیریت\/ باز و بستن شعب"},{"Id":"AA504703-ED2A-4D9F-842F-5392DA97FB5D","Name":"مدیریت\/ برندها"},{"Id":"44269C20-A3EA-4A47-9ABD-56E87512440D","Name":"مدیریت\/ مدیریت شعب"},{"Id":"D07DAAFA-D62E-4EE4-917D-5DA1526038FF","Name":"مدیریت\/ سال مالی"},{"Id":"5CE32FE2-A039-4903-A5B2-6068A690586B","Name":"مدیریت\/ واحدهای محصول"},{"Id":"AD40C649-D728-42DC-A857-69D29A056C7B","Name":"مدیریت\/ موجودی اولیه"},{"Id":"81AD1F04-16E9-49F5-B9CD-70E93B4088B0","Name":"مدیریت\/ کارت های بانکی"},{"Id":"4E55084C-EBC6-400F-9661-71D8775F505D","Name":"مدیریت\/ تنظیم قیمت"},{"Id":"1AD3E001-7717-44E1-A200-7417C052DA2A","Name":"مدیریت\/ کشورها"},{"Id":"82C9E303-5DCD-400C-BCE8-74491E12DE86","Name":"مدیریت\/ کارتابل دریافت"},{"Id":"501AB328-B2A0-4FF8-8B70-752A0AF4ECFD","Name":"مدیریت\/واحدهای پولی"},{"Id":"8BB3093A-C888-4AC2-8383-7B666B7F3EB2","Name":"مدیریت\/ شعبه بانک ها"},{"Id":"2E7C97D2-D59D-4C06-AFC4-8A7F3139867B","Name":"مدیریت\/ layout های انبار"},{"Id":"67A6E2BD-C246-AAD1-2547-8BAEA2C66C54","Name":"مدیریت\/ شماره تماس پرسنل ها"},{"Id":"D976E2BE-CD26-4645-89EF-8BAEA2C66C54","Name":"مدیریت\/ دسترسی به انبارها"},{"Id":"69CFDC4E-5E02-4A2D-BEA2-8EDBD2855212","Name":"مدیریت\/ لیست فاکتورها"},{"Id":"388B72EA-C3BB-4043-BE85-9076FD65A4CB","Name":"مدیریت\/ ثبت فاکتور خرید"},{"Id":"243500C7-858F-41D0-BE97-91618E5F54E0","Name":"مدیریت\/محصول ها"},{"Id":"E7AA2F2A-40BC-4919-A8CB-920DF052AF6F","Name":"مدیریت\/ گردش حساب مشتری"},{"Id":"B8D3A705-9B8F-4699-BA7A-92688A41A037","Name":"مدیریت\/ درخواست‌های فاکتورهای مرجوعی"},{"Id":"B2E6B453-9D99-4B41-8802-93EB2B0E4C42","Name":"مدیریت\/حکم ها"},{"Id":"C4B0307F-F2F6-4488-B553-9EF36DC96403","Name":"مدیریت\/ حساب های شبا"},{"Id":"A3A989C6-394E-4133-A279-A34ED1A3A656","Name":"مدیریت\/ ایجاد فاکتور"},{"Id":"EF0BC55C-FEB1-439D-93B3-AE68329404EC","Name":"مدیریت\/ تغییر رمز عبور"},{"Id":"4B74FE84-1F12-4F5F-A213-AEB16FAB72C9","Name":"مدیریت\/قیمت دلار"},{"Id":"1BDFF31A-9A83-48AE-B027-B24CDF8F750D","Name":"مدیریت\/اعتبار شعب"},{"Id":"6FF9BF6F-C5D0-4546-92D1-B8B45F0AD5C3","Name":"مدیریت\/ مدیریت مشتریان"},{"Id":"C3C30A86-3748-4881-B9E3-BC3677DD3B42","Name":"مدیریت\/رنگ ها"},{"Id":"BF121AC9-E8BE-4648-9C0D-CB4FDDE0FA69","Name":"مدیریت\/تنظیم دسترسی های پرسنل"},{"Id":"CA5C07E4-BAC8-400A-892F-D027C3A70B5A","Name":"مدیریت\/ حساب های پوز"},{"Id":"19371EC0-3FBA-4E8D-B34B-D2A757CCF1C7","Name":"مدیریت\/ کاردکس"},{"Id":"994BBA1B-932F-4119-9A55-DBD95069737F","Name":"مدیریت\/ کارتابل ارسال"},{"Id":"0C4FE3B2-2A5D-45E7-A23C-DD4D1771955B","Name":"مدیریت\/ انبار به انبار کد به کد"},{"Id":"055036A3-7BDB-437B-81D0-DE906C08AC42","Name":"مدیریت\/پرسنل ها"},{"Id":"5EC244E9-665E-492F-BB42-DE9FF298DE33","Name":"مدیریت\/ کد کالا"},{"Id":"07D7DE06-AF10-4DC2-9806-DF4254E9E645","Name":"مدیریت\/ تنظیم جایگزین های کدهای کالا"},{"Id":"47D2ACCC-F73D-47A2-969B-E8A1117590E4","Name":"مدیریت\/ جستجوی کالا"},{"Id":"E2EB5F80-AF14-4894-85E2-ECF5B92414A0","Name":"مدیریت\/تنظیم دسترسی"},{"Id":"6E3C0535-6E62-49D6-8DCF-F09C34967C59","Name":"مدیریت\/ شهرها"},{"Id":"431C0254-1E62-43D6-1DCF-F09C41967C59","Name":"مدیریت\/ بانک ها"},{"Id":"1D1B5F77-8D30-4F9D-80DE-F3228C94D56B","Name":"مدیریت\/ حساب های بانکی"},{"Id":"ad1adc26-8f84-4af7-b949-330ded5ebd8c","Name":"انبارگردانی"},{"Id":"0d919e04-5351-4a17-b003-1bcbe56007ae","Name":"قیمت"},{"Id":"cf53ae2e-918b-40eb-bf07-ff3ae09b0e21","Name":"موجودی دسته ای"},{"Id":"52bbe7b2-32d1-440a-a32a-d08998ed544f","Name":"خرید معصومی"},{"Id":"d098d4ae-4715-4f42-ac4f-e35a3bc91e85","Name":"لیست خرید معصومی"},{"Id":"A2687B8B-7096-4D7E-B990-4AA9644FE365","Name":"مالی/لیست دریافت ها و پرداخت ها"},{"Id":"ab566e67-9855-49fa-9e54-a9b279f5aff4","Name":"ایجاد کالای معیوب"},
            //     {"Id":"2802dbf6-34d6-4141-ab8a-64a2ce857904","Name":"انبار/لیست انتقالی های احتیاط"},
            //     {"Id":"e572f2aa-35ed-4a84-99b6-12228acd0c63","Name":"گردش حساب مشتری شعب"},
            //     {"Id":"87f8e902-31e3-41f9-8240-c2da61934f93","Name":"گردش حساب شعب شعب"},
            //     {"Id":"77661c0f-5d8a-4877-a906-656c5fbf14b4","Name":"انتقال شغب"},
            //     {"Id":"eb30c481-12eb-44fa-8a43-a68943d53ed2","Name":"مالی/گردش حساب مشتری شعب - مدیریت"},
            //     {"Id":"08fda8df-ee9e-427a-af89-a912e338da19","Name":"مالی/گردش حساب شعب شعب - مدیریت"},
            //     {"Id":"f15a6fab-34ba-4364-89b3-d70b20bbdeff","Name":"مالی/بدهکاران بستانکاران شعب"},
            //     {"Id":"8f8a3f97-6177-494e-b69d-f402967a2f07","Name":"مالی/گزارش سود شعب"}
            // ]);
            let forms : AccessibleFormViewModel[] = result.Forms.map(x => {
                let r = new AccessibleFormViewModel(this);
                r.formId = x.Id;
                r.formName = x.Name;
                r.processFormId = x.ProcessFormId;
                r.processFormName = x.ProcessFormName;
                r.position = x.Position;
                return r;
            });
            let menu = new Menu();
            forms.forEach(x=>menu.addChild(x.formName.split('/'),x.position,x));
            menu.sort();
            forms = menu.getSortedData();
            this.accessibleForms.update(...forms);
            this.writtenText = "";
            this.filteredAccessibleForms.update(...this.accessibleForms);
            this.updateSideBarItems();
        }
        catch (ex) {
            console.log(ex);
        }         
        finally{
            this.isLoading = false;
        }
    }
    private timer:any;
    startFilter() {
        if(this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.filteredAccessibleForms.update(...this.accessibleForms.filter(x => x.formName.includes(this.writtenText)));
            this.updateSideBarItems();
        }, 200);

    }

    updateSideBarItems()
    {
        this.accessibleItems.clear();
        let tempArray: SideBarItem[] = new Array();
        this.filteredAccessibleForms.forEach(element => {
            this.CreateAccessibleFormChains(element);
        });
        this.accessibleItems.forEach(element => {
            let sideBarItem = element.getCorrespondingSideBarItem();
            tempArray.push(sideBarItem);
        });
        this.sideBarItems = tempArray.slice();
    }

    CreateAccessibleFormChains(form: AccessibleFormViewModel){
        let parts: string[] = form.formName.split("/");
        let lastChainedItem: AccessibleItem = null;
        while (parts.length != 0){
            if (lastChainedItem == null){
                if (this.accessibleItems.has(parts[0])){
                    lastChainedItem = this.accessibleItems.get(parts[0]);
                    parts.splice(0, 1);
                    continue;
                }
                break;
            }
            else{
                if (lastChainedItem.hasChild(parts[0])){
                    let targetChild = lastChainedItem.getChild(parts[0]);
                    lastChainedItem = targetChild;
                    parts.splice(0, 1);
                    continue;
                }
                break;
            }
            
        }
        for (let index = 0; index < parts.length; index++) {
            let accessibleItem = new AccessibleItem();
            accessibleItem.name = parts[index];
            accessibleItem.iconClass = "";
            if (index == parts.length - 1){
                accessibleItem.accessibleForm = form;
            }
            if (index == 0 && lastChainedItem == null){
                this.accessibleItems.set(accessibleItem.name, accessibleItem);
                lastChainedItem = accessibleItem;
                continue;
            }
            lastChainedItem.children.push(accessibleItem);
            lastChainedItem = accessibleItem;
        }
    }
}

export class AccessibleFormViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set formName(v: string) { this._formName = v; } public get formName(): string { return this._formName;} private _formName: string;
    public set formId(v: string) { this._formId = v; } public get formId(): string { return this._formId;} private _formId: string;
    public set processFormId(v: string) { this._processFormId = v; } public get processFormId(): string { return this._processFormId;} private _processFormId: string;
    public set processFormName(v: string) { this._processFormName = v; } public get processFormName(): string { return this._processFormName;} private _processFormName: string;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position;} private _position: number;
    
    select(){
        if(stringIsNullOrEmpty(this.processFormId)==false){
            let message = new CreateWindowMessage('5ec1473c-34a7-467a-9ec4-b039fa416a8c');
            message.isProcessForm = true;
            message.processFormId = this.processFormId;
            message.processFormName = this.formName.split('/').at(-1);
            this.handleMessage(message);
        }else{
            let message = new CreateWindowMessage(this.formId);
            this.handleMessage(message);

        }
    }
}


export class CreateWindowMessage extends ViewModelMessage{
    public windowId:string;
    public isProcessForm:boolean;
    public processFormId:string;
    public processFormName:string;

    constructor(windowId:string) {
        super();
        this.windowId = windowId;
    }
}
export class ShowWindowMessage extends ViewModelMessage{
    public generator:(parent:ViewModel)=>WindowViewModel;
    constructor(generator:(parent:ViewModel)=>WindowViewModel) {
        super();
        this.generator = generator;
    }

    async furtherLoading(window:WindowViewModel){

    }
}

export class AccessibleItem{
    constructor() {
        this.children = ObservableArray.create<AccessibleItem>();
    }
    public name: string;
    public iconClass: string;
    public accessibleForm: AccessibleFormViewModel;
    public set children(v: ObservableArray<AccessibleItem>) { this._children = v; } public get children(): ObservableArray<AccessibleItem> { return this._children;} private _children: ObservableArray<AccessibleItem>;
    
    hasChild(key:string) : boolean {
        for (let index = 0; index < this.children.length; index++) {
            const child = this.children[index];
            if (child.name == key){
                return true;
            }
        }
        return false;
    }

    getChild(key:string): AccessibleItem {
        for (let index = 0; index < this.children.length; index++) {
            const child = this.children[index];
            if (child.name == key){
                return child;
            }
        }
        return null;
    }

    getCorrespondingSideBarItem() : SideBarElement {
        let element = new SideBarElement();
        element.name = this.name;
        element.iconClass = this.iconClass;
        element.command = this.accessibleForm ? () => {this.accessibleForm.select()} : () => {}
        if (this.children.length == 0) return element;
        element.childItems.push(...this.children.map(x => x.getCorrespondingSideBarItem()));
        return element;
    }
}

export class SideBarElement implements SideBarItem{
    name:string;
    iconClass:string;
    command:()=>void;
    childItems:SideBarItem[] = new Array();
}


class Menu{
    name:string;
    children:Menu[];
    relatedData : AccessibleFormViewModel;
    orderNo : number;
    constructor() {
        this.children = [];
    }

    addChild(name:string[],orderNo:number,data:AccessibleFormViewModel){
        let childName = name.shift();
        if(name.length==0){
            let newChild = new Menu();
            newChild.name = childName;
            newChild.orderNo = orderNo;
            newChild.relatedData = data;
            this.children.push(newChild);
        }else{
            let relatedChild = this.children.filter(x=>x.name == childName).at(0);
            if(relatedChild==null){
                let newChild = new Menu();
                newChild.name = childName;
                this.children.push(newChild);
                relatedChild = newChild;
            }
            relatedChild.addChild(name,orderNo,data);
        }
    }

    sort(){
        if(this.children.length>0){
            this.children.forEach(x=>x.sort());
            this.orderNo = this.children.reduce((a,c)=>a<c.orderNo ? a : c.orderNo,32000);
            this.children.sort((x,y)=>x.orderNo-y.orderNo);
        }
    }

    getSortedData():AccessibleFormViewModel[]{
        if(this.children.length==0){
            return [this.relatedData];
        }else{
            let result:AccessibleFormViewModel[] = [];
            this.children.forEach(x=>result.push(...x.getSortedData()));
            return result;
        }
    }
}